import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl } from '@angular/forms';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { Observable, Subscription, debounceTime, map } from 'rxjs';
import { SubSectionData } from 'src/app/model/help';
import { Lang } from 'src/app/model/lang';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectHelpSearchList } from 'src/app/store/help/help.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
  templateUrl: './helper-view-guest.dialog.component.html',
})

export class HelperViewGuestDialogComponent  implements OnInit, OnDestroy {
	currentLang: Lang;
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	helpSearchList$: Observable<SubSectionData[] | undefined>;
	helpSearchListSub: Subscription | undefined;

	helpSearchList: SubSectionData[];

	filterSub: Subscription;
	searchFilter: FormControl = new FormControl('');
	filter: '';

	roleUser: string;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		){
		this.initSelectors();
	}

	ngOnInit(): void {
		this.filter= '';
		this.filterSub = this.searchFilter.valueChanges.pipe(
			debounceTime(500),
			map(v => v.trim().toLowerCase())
		).subscribe(value => {
			this.filter = value;
			this.store.dispatch(HelpActions.getHelpGuestSearch({ filter: this.filter, appid:'frontend'}));
		});
		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.currentLangSub = this.currentLang$?.subscribe((lang) => {
			this.currentLang = lang;
			if (this.filter===''){
				this.store.dispatch(HelpActions.getHelpGuest({appid:'frontend'}));
			} else {
				this.store.dispatch(HelpActions.getHelpGuestSearch({ filter: this.filter, appid:'frontend'}));
			}
		});
		this.helpSearchListSub = this.helpSearchList$.subscribe((helpSearchList) => {
			this.helpSearchList = helpSearchList;
		});
	}

	initSelectors(): void{
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.helpSearchList$ = this.store.select(selectHelpSearchList);
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
		this.helpSearchListSub?.unsubscribe();
	}

	accordionAction(): void {
		const listaFrames = document.getElementsByTagName('iframe');

		for (let index = 0; index <= listaFrames.length; index++) {
			if (listaFrames[index]!== undefined){
					const iframe = listaFrames[index].contentWindow;
					iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}
	}

	closeDialog(): void{
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	dynamicButtonWidth() : string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
